export function parseTimestampToMs(timestamp: number | string): number | null {
  if (!timestamp) return null;

  if (typeof timestamp === 'string') {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return null;
    return date.getTime();
  }

  return timestamp > 10000000000 ? timestamp : timestamp * 1000;
}
